export const PageWrapper = ({children}) => <>{children}</>